module.exports = __webpack_public_path__ + "static/img/data_3.04b83bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data_3.jpg
// module id = 18sE
// module chunks = 1